module.exports = __webpack_public_path__ + "static/2018_Tax_Variation_Checklist.v3-60501673b333b7503758f86fdc0552e1.pdf";